import { render, staticRenderFns } from "./bestResult.vue?vue&type=template&id=6ff9cc7a&scoped=true&"
import script from "./bestResult.vue?vue&type=script&lang=js&"
export * from "./bestResult.vue?vue&type=script&lang=js&"
import style0 from "./bestResult.vue?vue&type=style&index=0&id=6ff9cc7a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ff9cc7a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
installComponents(component, {VBtn})
